itsoftApp.createModule("routes", ["metriks"], function() {
    var boxId = "#js-box";
    var box = $(boxId);
    var hrefItemClass = ".js-href";
    var hrefItem = $(hrefItemClass);

    if (!box.length || !hrefItem.length) {
        return false;
    }

    var contentClass = ".js-content";
    var changeClass = "is-change";
    var newClass = "is-new";
    var delayAttr = "data-delay";
    var delayAnimated;

    // обработка нажатия на сслку
    hrefItem.on("click", function(e) {
        DEBUG && console.log("[module ajaxLoad] click");
        e.preventDefault();

        // отменяет повторный вызов функции до завершения предыдущего перехода
        if (itsoftApp.ajaxDisabled) {
            return false;
        }

        var self = $(this);
        var href = self.attr("href");
        var selfUrl = document.location.pathname;
        delayAnimated = self.attr(delayAttr) / 1;

        // обработка времени перехода между страницами
        if (!delayAnimated) {
            delayAnimated = 0;
        }

        // если ссылка на текущую страницу, то прервать выполнение
        if (selfUrl == href) {
            return false;
        }

        getContent(href, true);
    });

    // анимация смена страниц
    function animatedTransition(html) {
        // начало перехода
        box.addClass(changeClass);

        // добавление нового контента и инициализация скриптов
        setTimeout(
            function() {
                box.removeClass(changeClass);
                box.html(html);
                itsoftApp.initAllModules();
            },
            delayAnimated
        );

        // задержка + 10 нужна для того,
        // чтобы новый контент появлялся с анимацией
        setTimeout(
            function() {
                var selfContent = box.find(contentClass);
                if (selfContent.length) {
                    selfContent.removeClass(newClass);
                }

                itsoftApp.ajaxDisabled = false;
            },
            (delayAnimated + 10)
        );

        delayAnimated = 0;
    }

    // Функция загрузки контента url - страница перехода;
    // addEntry - флаг, добавлять или нет  новое состояние в историю браузера ;
    // selfUrl - текущая страница
    function getContent(url, addEntry, selfUrl) {
        itsoftApp.ajaxDisabled = true;
        var request = $.get(url);

        // отработает в случае успешного запроса
        var done = function(data) {
            var dataThis = $(data).find(boxId);
            // добавляем служебный класс для анимированного перхода
            // у добавленного блока
            var selfContent = dataThis.find(contentClass);

            if (selfContent.length) {
                selfContent.addClass(newClass);
            }

            var dataThisHtml = dataThis.html();

            // елси на странице перехода нет контента, то прервать выполнение
            // вернуть 404
            if (dataThisHtml) {
                animatedTransition(dataThisHtml);
            }
            else {
                getContent("404.php", true);
                return false;
            }

            // добавляет новое состояние в историю браузера
            // и передает данные метрикам
            if (addEntry == true) {
                DEBUG && console.log("[module ajaxLoad] pushState");
                itsoftApp.modules.metriks.metriksAjaxHreh(url, selfUrl);
                history.pushState(null, null, url);
            }

            DEBUG && console.log("[module ajaxLoad] request done");
        };

        // отработает в случае ошибки
        var fail = function(err) {
            DEBUG && console.log("[module ajaxLoad] request fail, error: ", err.status);

            // переключение флага для того,
            // чтобы была возможность снова переходить по ссылкам.
            itsoftApp.ajaxDisabled = false;


            if (request.status == 404) {
                getContent("404.php");
            }

            // TODO обработчик ошибки страницы 404
        };

        // отработает всегда
        var always = function() {
            DEBUG && console.log("[module ajaxLoad] request always");
        };

        request.done(done);
        request.fail(fail);
        request.always(always);
        DEBUG && console.log("[module ajaxLoad] request sent");
    }

    // сохраниние истории браузера
    window.addEventListener("popstate", function() {
        DEBUG && console.log("[module ajaxLoad] back");
        // Передаем текущий URL
        getContent(location.pathname, false);
    });

});